// extracted by mini-css-extract-plugin
export var emailBlockLink = "_o6-0";